import React, { useEffect, useReducer } from 'react';
import { Badge, Button, Checkbox, Grid, MenuItem, Select, Switch, Typography } from '@material-ui/core';
import { NotificationManager } from "react-notifications";
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { client } from '../../config/apollo';
import { UPDATE_IN_PROGRESS_BOOKING } from "../../graphql/mutations/booking";
import { primaryColor, webFont } from '../../config/theme';
import { setIsRecurringBooking } from '../../redux/bookings';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import format from 'date-fns/format';
import { GET_CALENDAR_SLOTS } from '../../graphql/queries/schedule';

class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', {locale: this.locale})
  }
}

const RepeatBookingStep = (props) => {
  const dispatch = useDispatch();
  const { selectedChefId, selectedDate,  selectedSlot, inProgressBooking, userId } = useSelector(store => ({
    selectedChefId: store.bookings.selectedChefId,
    selectedDate: store.bookings.selectedDate,
    selectedSlot: store.bookings.selectedSlot,
    inProgressBooking: store.bookings.inProgressBooking,
    userId: store.auth.userId,
  }), shallowEqual);

  const [state, setState] = useReducer((oldProps, newProps) => ({ ...oldProps, ...newProps }), {
    isRecurring: props.isRecurring || false,
    repeatCount: 1,
    repeatDays: [],
    scheduleMonth: moment().format('MM'),
    datePickerRef: true,
    monthlySlots: [],
    start: '',
    end: ''
  });

  useEffect(() => {
    const { chef } = props;
    client.query({
      query: GET_CALENDAR_SLOTS,
      variables: {
        chefId: selectedChefId ? selectedChefId : chef ? chef.id : null,
          start: moment(state.scheduleMonth, 'MM')
          .startOf("month")
          .format("YYYY-MM-DD"),
          end: moment(state.scheduleMonth, 'MM')
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      fetchPolicy: "network-only"
    })
      .then(response => {
        setState({ monthlySlots: response.data })
      })
      .catch(err => console.error('ERROR FETCHING SLOTS FOR THE GIVEN MONTH', state.scheduleMonth, err));
  }, [selectedChefId, props.chef, state.scheduleMonth]);

  useEffect(() => {
    if (selectedSlot) {
      if (selectedSlot.start) {
        setState({
          start: moment(selectedSlot.start, 'HH:mm').format('hh:mm a'),
          end: moment(selectedSlot.end, 'HH:mm').format('hh:mm a')
        });
      }
    }
  }, [selectedSlot]);

  useEffect(() => {
    if (selectedDate) {
      setState({
        repeatDays: [...new Set([...state.repeatDays, moment(selectedDate).format('DD MMM YYYY')])],
        scheduleMonth: moment(selectedDate).format('MM')
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (state.isRecurring) {
      const today = moment();
      if (state.repeatDays.length === 2) {
        const repeatDay1 = moment(state.repeatDays[0]);
        if (repeatDay1.isSame(today)) {
          const updatedDays = state.repeatDays;
          updatedDays.shift();
          setState({ repeatDays: updatedDays });
        }
      }
    }
  }, [state.isRecurring, state.repeatDays]);

  console.log('MONTHLY SLOTS: ', state.monthlySlots)

  const isInSchedule = date => {
    const { monthlySlots } = state;

    if (monthlySlots) {
      const { getCalendarSlots } = monthlySlots;
      let isAvailable = false;

      if (getCalendarSlots)
        isAvailable = getCalendarSlots.find(day => {
          return day.date === moment(date).format("YYYY-MM-DD");
        });

      return !!isAvailable;
    }

    return false;
  }

  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
    let inDate = moment(date);
    const inCompDate = inDate.format("YYYY") + "-" + inDate.format("MM") + "-" + inDate.format("DD");
    inDate = moment(inCompDate);
    let today = moment(new Date());
    const compToday = today.format("YYYY") + "-" + today.format("MM") + "-" + today.format("DD");
    today = moment(compToday);

    if (inDate.isBefore(today)) {
      return <Badge>{dayComponent}</Badge>;
    }
    else {
      return <Badge badgeContent={<span
        style={{
          fontSize: 30,
          fontWeight: 500,
          color: isInSchedule(date) ? "green" : "white"
        }}
      >
                .
                </span>}>{dayComponent}</Badge>;
    }
  };

  const handleDaysSelection = day => {
    const selectedDay = moment(day).format('DD MMM YYYY');
    const comparisonDate = moment(day).format('YYYY-MM-DD');
    const { monthlySlots, repeatDays } = state;

    if (monthlySlots && !Array.isArray(monthlySlots)) {
      if (monthlySlots.getCalendarSlots) {
        if (monthlySlots.getCalendarSlots.length) {
          const slotDayIndex = monthlySlots.getCalendarSlots.findIndex(item => item.date === comparisonDate);
          if (slotDayIndex > -1) {
            const updatedDays = [...repeatDays];
            if (updatedDays.length === 1) {
              const today = moment().add(1, 'days').format('DD MMM YYYY');
              const repeatDay1 = moment(day).format('DD MMM YYYY');
              if (repeatDay1 === today) {
                return;
              }
            }

            if (updatedDays.length === 26) {
              NotificationManager.error('You can only select upto 26 days.', 'Booking', 4000);
              return;
            }

            const exIndex = updatedDays.findIndex(item => item === selectedDay);

            if (exIndex < 0) {
              updatedDays.push(selectedDay);
              NotificationManager.info(`Day selected: ${selectedDay}`, 'Booking', 2000);
            } else {
              updatedDays.splice(exIndex, 1);
              NotificationManager.info(`Day removed: ${selectedDay}`, 'Booking', 2000);
            }

            updatedDays.sort((a,b) => {
              return a > b ? 1 : a < b ? -1 : 0;
            })

            setState({ repeatDays: updatedDays, scheduleMonth: moment(day).format('MM') });

          } // end-if slot day index
        } // end-if monthly slots length
      } // end-if monthly slots get calendar slots
    } // end-if monthly slots
  };

  const handleNext = () => {
    const { isRecurring, repeatCount, repeatDays } = state;
    const payload = {
      userId,
      chefId: selectedChefId || props.chef.id,
      isRecurring
    };

    if (isRecurring) {
      payload.repeatCount = repeatCount;
      payload.repeatDays = repeatDays
    }

    dispatch(setIsRecurringBooking(isRecurring));

    client
      .mutate({
        mutation: UPDATE_IN_PROGRESS_BOOKING,
        variables: {
          bookingId: inProgressBooking,
          booking: payload
        }
      })
      .then(response => {
        props.changeProgressStep(3);
      })
      .catch(err => { console.log('ERROR updating repeat for Booking') });
  };

  const toggleDatePicker = () => { setState({ datePickerRef: !state.datePickerRef }) };

  return (<div>
    <Grid container>

      <Grid item xs={12}>
        <Typography
          style={{
            ...styles.setFont,
            fontSize: 24,
            fontWeight: 500,
            marginBottom: 30,
            color: '#000000'
          }}
        >
          Want this to be a recurring booking?
        </Typography>
      </Grid>

      <Grid item xs={12} style={{ display: 'flex' }}>
        <p style={{
          fontSize: 18,
          fontFamily: webFont,
          fontWeight: 500
        }}>
          Repeat
        </p>
        <div data-test-id={"recurring"} className="recurring-switch-wrapper">
          <Switch

          data-test-id={"repeatswitch"}
            checked={state.isRecurring}
            onChange={() => setState({ isRecurring: !state.isRecurring })}
            style={{ marginTop: 10 }}
          />
        </div>
      </Grid>

      {state.isRecurring && <Grid item xs={12}>
        <p data-test-id={"fromtorepeatdays"}style={{ fontWeight: 500, fontSize: 18 }}>
          Select days to recur for appointment slot <br />{state.start} - {state.end}
        </p>

        <div data-test-id={"calendarrepeat"} className={"booking-step2-calendar-wrapper"}>
        <MuiPickersUtilsProvider data-test-id={"choosedates"} utils={FrDateFnsUtils}>
          <DatePicker
            style={{...styles.setFont, color: primaryColor, display: "none",}}
            animateYearScrolling
            autoOk={false}
            onChange={handleDaysSelection}
            onMonthChange={date => {
              setState({ scheduleMonth: moment(date).format('MM') })
            }}
            onAccept={(d) => {}}
            onClose={toggleDatePicker}
            minDate={moment().add(1, 'days').toDate()}
            open={state.datePickerRef}
            renderDay={renderWrappedWeekDay}
            variant={"static"}
          />

          {/*<Calendar
            style={{...styles.setFont, color: primaryColor, display: "none",}}
            onChange={(d) => handleDaysSelection(d)}
            minDate={moment().add(1, 'days').toDate()}
            renderDay={renderWrappedWeekDay}
          />*/}

          <Typography
            align={"center"}
            style={{
              ...styles.setFont,
              fontSize: 16,
              color: primaryColor,
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              marginTop: 10
            }}
          >
            {state.repeatDays.sort((a, b) => moment(a).unix() - moment(b).unix()).map(rDay => (
              <>
                <span data-test-id={"showrepeat"} style={{ marginBottom: -15 }}>{moment(rDay).format('DD MMM YYYY, dddd')}</span>
                <br />
              </>
            ))}
          </Typography>

        </MuiPickersUtilsProvider>
        </div>
      </Grid>}

      <Grid container style={{marginTop: 40, marginBottom: 10, alignItems: 'center'}} justify="center" direction="column">
        <Grid item>
          <Button
            data-test-id={"bkgonenext"}
            style={{...styles.setFont, ...styles.nextBtn}}
            onClick={handleNext}
          >
            Next
          </Button>
        </Grid>
      </Grid>

    </Grid>
  </div>);
};

export default RepeatBookingStep;

const styles = {
  setFont: {
    fontFamily: webFont
  },
  error: {fontSize: 12, color: "red", fontFamily: webFont},
  chefImg: {
    width: 60,
    height: 60,
    // objectFit: "contain",
    borderRadius: "50%"
  },
  inputText: {
    fontFamily: webFont,
    fontSize: 16,
    fontWeight: 300,
    marginLeft: 15,
    textAlign: 'center',
    width: 40
  },
  inputTextPrice: {
    fontFamily: webFont,
    fontSize: 16,
    fontWeight: 300,
    marginLeft: 15,
    textAlign: 'center',
    width: 70
  },
  nextBtn: {
    minWidth: 240,
    height:48,
    textAlign: "center",
    borderRadius: 24,
    backgroundColor: primaryColor,
    color: "#fff",
    textTransform: 'none',
    fontWeight: 'normal',
    fontSize: 18,
  },
  setColor: {
    color: primaryColor
  },
  setRoundedIcon: {
    borderRadius: "50%",
    borderColor: primaryColor
  },
  updateBtn: {
    minWidth: 240,
    height:48,
    textAlign: "center",
    borderRadius: 24,
    borderColor: primaryColor,
    borderWidth: 1,
    color: primaryColor,
    backgroundColor: "#fff",
    textTransform: 'none',
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: 5
  }
};
